import type { CustomCellEditorProps } from "ag-grid-react";
import { useState } from "react";
import { DateOnlyPicker } from "widgets";

import type { CellEditorParams } from "@/ui-modules/core/grid/cell-editor-factory.js";

import { TableCell } from "../core/TableCell.js";

export const DateCellEditor = (props: CustomCellEditorProps<string> & CellEditorParams) => {
  // useState initialization: make sure to init a proper date value, in case the user does not pick any date
  const [date, setDate] = useState<string>(props.value);

  const onChangeListener = (ISOFormattedDate?: string | null) => {
    setDate(ISOFormattedDate ?? "");
    props.onValueChange(ISOFormattedDate);
  };

  return (
    <TableCell editor>
      <DateOnlyPicker
        ISOFormattedDate={date}
        onChange={onChangeListener}
        onClose={() => setTimeout(() => props.stopEditing())}
        autoFocus={true}
        defaultOpen={false}
        preventTimezoneConversion={true}
      />
    </TableCell>
  );
};
